module.exports = __webpack_public_path__ + "img/crane-worry.bf575aca.png";